export const formatMessage = (error) => {
  return error.data["hydra:description"].split(':')[1].trim()
}